import React from 'react';

export default function CustomCheckbox({ label, value, checked, onChange }) {
    return (
        <label
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                cursor: 'pointer'
            }}
        >
            <input
                type="checkbox"
                value={value}
                checked={checked}
                onChange={onChange}
                style={{
                    position: 'absolute',
                    opacity: 0,
                    width: 0,
                    height: 0,
                    pointerEvents: 'none',
                }}
            />
            <span
                style={{
                    width: 16,
                    height: 16,
                    border: '1px solid #999',
                    borderRadius: 2,
                    background: checked ? '#007A84' : 'transparent',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    fontSize: 12,
                    fontWeight: 'bold',
                }}
            >
                {checked ? '✓' : ''}
            </span>
            <span style={{ color: checked ? '#007A84' : '#757575' }}>{label}</span>
        </label>
    );
}
